module.exports = __webpack_public_path__ + "img/p008.8d7b1dbd.png";